export function debounce(callback, delay = 100, canceller = () => { }) {
    let timerId;
    canceller(() => {
        window.clearTimeout(timerId);
    });
    return function (...args) {
        if (timerId !== undefined) {
            window.clearTimeout(timerId);
        }
        timerId = window.setTimeout(() => {
            callback(...args);
            timerId = undefined;
        }, delay);
    };
}
//# sourceMappingURL=debounce.js.map